import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedMultiplierTypeSelector($companyId: ID!, $id: ID) {
    multiplierTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        multiplierType
        summary
      }
    }
  }
`

export const Query = gql`
  query MultiplierTypeSelector(
    $companyId: ID!,
    $filters: MultiplierTypeFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    multiplierTypes(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        multiplierType
        summary
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
